import React from 'react';
import { useField } from 'react-final-form';
import { useToggleMapping } from '../../../providers/Toggle';
import Input from '../../Input';
export default function TextMoped(props) {
    /**
     * !! HACK SPECIFIC TO Moped banner
     */
    const group = 'mopedRegOrYear';
    const toggleMapping = useToggleMapping();
    const {
        input: { value }
    } = useField(toggleMapping[group]?.fieldName);
    return toggleMapping[group][value] === props.fieldId ? <Input {...props} /> : null;
}
